import { BaseApi } from '../baseApi';
import type { APIResponse } from '../config';
import type { DashboardData, TeacherDashboardData } from '../../../types/models';

export type { TeacherDashboardData };

export interface OrganizationDashboardData {
    // Add organization dashboard specific fields
    total_opportunities: number;
    total_applications: number;
    active_opportunities: number;
    recent_applications: Array<{
        id: number;
        student_name: string;
        opportunity_title: string;
        status: string;
        applied_at: string;
    }>;
}

export class DashboardApi extends BaseApi {
    async getStudentDashboard(): Promise<APIResponse<DashboardData>> {
        try {
            const response = await this.makeGet<APIResponse<DashboardData>>('/student/dashboard/');
            console.log('Student dashboard response:', response);
            return response;
        } catch (error) {
            console.error('Error fetching student dashboard:', error);
            throw error;
        }
    }

    async getTeacherDashboard(): Promise<APIResponse<TeacherDashboardData>> {
        try {
            const response = await this.makeGet<APIResponse<TeacherDashboardData>>('/teacher/dashboard/');
            console.log('Teacher dashboard response:', response);
            return response;
        } catch (error) {
            console.error('Error fetching teacher dashboard:', error);
            throw error;
        }
    }

    async getOrganizationDashboard(): Promise<APIResponse<OrganizationDashboardData>> {
        try {
            const response = await this.makeGet<APIResponse<OrganizationDashboardData>>('/organization/dashboard/');
            console.log('Organization dashboard response:', response);
            return response;
        } catch (error) {
            console.error('Error fetching organization dashboard:', error);
            throw error;
        }
    }

    async getDashboard(role: string): Promise<APIResponse<DashboardData | TeacherDashboardData | OrganizationDashboardData>> {
        switch (role) {
            case 'student':
                return this.getStudentDashboard();
            case 'teacher':
                return this.getTeacherDashboard();
            case 'organization':
                return this.getOrganizationDashboard();
            default:
                throw new Error(`Unsupported user role: ${role}`);
        }
    }
} 